import { useEffect, useCallback } from 'react'

let notifyFileModifiedGlobal = null

export const Notification = (props) => {

    const sendFileModification = useCallback(async (fileVersion) => {
        try {
            const response = await fetch(process.env.REACT_APP_U1_VIEWERSVC_LIVE.replace('/live', '/live/file-modified'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fileName: fileVersion,
                    caseId: props.caseId,
                    anonymous: !props.connected
                })
            });

            if (response.ok) {
                console.log('File modification sent successfully');
            } else {
                console.error('Failed to send file modification');
            }
        } catch (error) {
            console.error('Error sending file modification:', error);
        }
    }, [props.caseId, props.connected])

    useEffect(() => {
        notifyFileModifiedGlobal = sendFileModification
        return () => {
            notifyFileModifiedGlobal = null
        }
    }, [sendFileModification])

    return null
}

export const notifyFileModified = (fileVersion) => {
    if (notifyFileModifiedGlobal) {
        notifyFileModifiedGlobal(fileVersion)
    }
}